module.exports = __webpack_public_path__ + "bd0710da036890d4e283e678f2a6c0e1.mp4";